import CardVoidedSyncStore from "app/Management/AsyncManagement/CardVoidedSync/CardVoidedSyncStore";
import CheckInVoidedAsyncStore from "app/Management/AsyncManagement/CheckInVoidedAsync/CheckInVoidedAsyncStore";
import FeeVoidedAsyncStore from "app/Management/AsyncManagement/FeeVoidedAsync/FeeVoidedAsyncStore";
import HisToCrmHistoryAsyncStore from "app/Management/AsyncManagement/HisToCrmHistoryAsync/HisToCrmHistoryAsyncStore";
import PatientMergeStore from "app/Management/AsyncManagement/PatientMerge/PatientMergeStore";
import ProductVoidedAsyncStore from "app/Management/AsyncManagement/ProductVoidedAsync/ProductVoidedAsyncStore";
import ServiceVoidedAsyncStore from "app/Management/AsyncManagement/ServiceVoidedAsync/ServiceVoidedAsyncStore";
import EmployeeStatusStore from "app/Management/Category/EmployeeStatus/EmployeeStatusStore";
import SalaryPeriodStore from "app/Management/Category/SalaryPeriod/SalaryPeriodStore";
import StaffGroupStore from "app/Management/Category/StaffGroup/StaffGroupStore";
import MenuStore from "app/Management/Menu/MenuStore";
import PermissionStaffStore from "app/Staff/PermissionStaff/PermissionStaffStore";
import ActivityLogStore from "./ActivityLog/ActivityLogStore";
import AppointmentAsyncStore from "./AsyncManagement/AppointmentAsync/AppointmentAsyncStore";
import AppointmentVoidedAsyncStore from "./AsyncManagement/AppointmentVoidedAsync/AppointmentVoidedAsyncStore";
import AsyncManagementStore from "./AsyncManagement/AsyncManagementStore";
import CardAsyncStore from "./AsyncManagement/CardAsync/CardAsyncStore";
import CheckInAsyncStore from "./AsyncManagement/CheckInAsync/CheckInAsyncStore";
import FeeAsyncStore from "./AsyncManagement/FeeAsync/FeeAsyncStore";
import PatientAsyncStore from "./AsyncManagement/PatientAsync/PatientAsyncStore";
import ProductAsyncStore from "./AsyncManagement/ProductAsync/ProductAsyncStore";
import ServiceAsyncStore from "./AsyncManagement/ServiceAsync/ServiceAsyncStore";
import TreatmentAsyncStore from "./AsyncManagement/TreatmentAsync/TreatmentAsyncStore";
import TreatmentVoidedAsyncStore from "./AsyncManagement/TreatmentVoidedAsync/TreatmentVoidedAsyncStore";
import AdministrativeUnitStore from "./Category/AdministrativeUnit/AdministrativeUnitStore";
import CountryStore from "./Category/Country/CountryStore";
import DiagnosticConceptTemplateStore from "./Category/DiagnosticConceptTemplate/DiagnosticConceptTemplateStore";
import EthnicsStore from "./Category/Ethnics/EthnicsStore";
import PositionStore from "./Category/Position/PositionStore";
import ProfessionStore from "./Category/Profession/ProfessionStore";
import PromotionProgramStore from "./Category/PromotionProgram/PromotionProgramStore";
import VatStore from "./Category/Vat/VatStore";
import ClientAwardTypeStore from "./ClientAwardType/ClientAwardTypeStore";
import ClientCardStore from "./ClientCard/ClientCardStore";
import AbstractProductStore from "./DrugAndMedicalSupplies/AbstractProduct/AbstractProductStore";
import BloodProductStore from "./DrugAndMedicalSupplies/BloodProduct/BloodProductStore";
import DosageStore from "./DrugAndMedicalSupplies/Dosage/DosageStore";
import DrugStore from "./DrugAndMedicalSupplies/Drug/DrugStore";
import DrugGroupStore from "./DrugAndMedicalSupplies/DrugGroup/DrugGroupStore";
import DrugInteractionsStore from "./DrugAndMedicalSupplies/DrugInteractions/DrugInteractionsStore";
import DrugRouteStore from "./DrugAndMedicalSupplies/DrugRoute/DrugRouteStore";
import DrugStoreInventory from "./DrugAndMedicalSupplies/DrugStore/DrugStoreInventory";
import IngusionFormulaStore from "./DrugAndMedicalSupplies/IngusionFormulaIndex/IngusionFormulaStore";
import MedicalSupplyStore from "./DrugAndMedicalSupplies/MedicalSupply/MedicalSupplyStore";
import MedicalSupplyRequestFormStore from "./DrugAndMedicalSupplies/MedicalSupplyRequestForm/MedicalSupplyRequestFormStore";
import MedicationRequestFormStore from "./DrugAndMedicalSupplies/MedicationRequestForm/MedicationRequestFormStore";
import QuantityUnitStore from "./DrugAndMedicalSupplies/QuantityUnit/QuantityUnitStore";
import StockOutStore from "./DrugAndMedicalSupplies/StockOutFromEMR/StockOutStore";
import EncounterTypeStore from "./EncounterType/EncounterTypeStore";
import GlobalPropotiesStore from "./ExamTemplate/GlobalPropoties/GlobalPropotiesStore";
import ICDCodeConceptStore from "./ExamTemplate/ICDCodeConcept/ICDCodeConceptStore";
import ICDCodeMedicationRequestFormStore from "./ExamTemplate/ICDCodeMedicationRequestForm/ICDCodeMedicationRequestFormStore";
import ICDCodeServiceStore from "./ExamTemplate/ICDCodeService/ICDCodeServiceStore";
import ICDMedicalSupplyRequestFormStore from "./ExamTemplate/ICDMedicalSupplyRequestForm/ICDMedicalSupplyRequestFormStore";
import ScreenTemplateStore from "./ExamTemplate/ScreenTemplate/ScreenTemplateStore";
import FundingSourceStore from "./FundingSource/FundingSourceStore";
import HospitalBedStore from "./HospitalBed/HospitalBedStore";
import IPTRStore from "./InsurancePaymentTypeRate/IPTRStore";
import ConceptAlertStore from "./ManageAlert/ConceptAlert/ConceptAlertStore";
import ConceptDrugStore from "./ManageAlert/ConceptDrug/ConceptDrugStore";
import ServiceConflicAlertStore from "./ManageAlert/ServiceAlert/ServiceConflicAlertStore";
import ConceptStore from "./ManageConcept/Concept/ConceptStore";
import ConceptAttributeTypeStore from "./ManageConcept/ConceptAttributeType/ConceptAttributeTypeStore";
import ConceptDataTypeStore from "./ManageConcept/ConceptDataType/ConceptDataTypeStore";
import ConceptFormStore from "./ManageConcept/ConceptForm/ConceptFormStore";
import ConceptSymptomStore from "./ManageConcept/ConceptSymptom/ConceptSymptomStore";
import ConceptTypeStore from "./ManageConcept/ConceptType/ConceptTypeStore";
import GlobalPropertyStore from "./ManageConcept/GlobalProperty/GlobalPropertyStore";
import HealthCheckCampainStore from "./ManageConcept/HealthCheckCampain/HealthCheckCampainStore";
import PatientTypeServiceStore from "./ManageConcept/PatientTypeService/PatientTypeServiceStore";
import ReasonCancelStore from "./ManageConcept/ReasonCancel/ReasonCancelStore";
import RevenueExpenditureStore from "./ManageConcept/RevenueExpenditure/RevenueExpenditureStore";
import SubclinicalSubjectStore from "./ManageConcept/SubclinicalSubject/SubclinicalSubjectStore";
import VoucherCategoryStore from "./ManageConcept/VoucherCategory/VoucherCategoryStore";
import HealthCareServiceStore from "./ManageService/HealthCareService/HealthCareServiceStore";
import InterestRatePeriodStore from "./InterestRatePeriod/InterestRatePeriodStore";
import ProductMappingStore from "./ManageService/ProductMapping/ProductMappingStore";
import RoomAndServiceStore from "./ManageService/RoomAndService/RoomAndServiceStore";
import SampleManagementStore from "./ManageService/SampleManagement/SampleManagementStore";
import ServiceFeeStore from "./ManageService/ServiceFee/ServiceFeeStore";
import ServiceGroupStore from "./ManageService/ServiceGroup/ServiceGroupStore";
import ServiceRequestSetStore from "./ManageService/ServiceRequestSet/SRSetStore";
import ServiceRequestSetTypeStore from "./ManageService/ServiceRequestSetType/ServiceRequestSetTypeStore";
import ServiceRoleStore from "./ManageService/ServiceRole/ServiceRoleStore";
import ServiceTypeStore from "./ManageService/ServiceType/ServiceTypeStore";
import SurgeryProcedureTypeStore from "./ManageService/SurgeryProcedureType/SurgeryProcedureTypeStore";
import MedicalEquipmentStore from "./MedicalEquipment/MedicalEquipmentStore";
import MedicalEquipmentTypeStore from "./MedicalEquipmentType/MedicalEquipmentTypeStore";
import MedicalRecordSectionConfigStore from "./MedicalRecord/MedicalRecordSectionConfig/MedicalRecordSectionConfigStore";
import MedicalRecordSummaryTypeStore from "./MedicalRecord/MedicalRecordSummaryType/MedicalRecordSummaryTypeStore";
import BuildingStore from "./Organizations/Building/BuildingStore";
import DepartmentStore from "./Organizations/Department/DepartmentStore";
import HealthCareRoomStore from "./Organizations/HealthCareRoom/HealthCareRoomStore";
import OrganizationStore from "./Organizations/Organization/OrganizationStore";
import SpecialistStore from "./Organizations/Specialist/SpecialistStore";
import StoreConfigStore from "./Organizations/StoreConfig/StoreConfigStore";
import PatientGroupTypeStore from "./PatientGroupType/PatientGroupTypeStore";
import PatientRankStore from "./PatientRank/PatientRankStore";
import PatientTypeStore from "./PatientType/PatientTypeStore";
import PaymentMethodStore from "./PaymentMethod/PaymentMethodStore";
import PersonAttributeTypeStore from "./PersonAttributeType/PersonAttributeTypeStore";
import CustomerSourceStore from "./Promotion/CustomerSource/CustomerSourceStore";
import CustomerSourceGroupStore from "./Promotion/CustomerSourceGroup/CustomerSourceGroupStore";
import MarketingStore from "./Promotion/Marketing/MarketingStore";
import MarketingVoucherStore from "./Promotion/MarketingVoucher/MarketingVoucherStore";
import RoleStore from "./Role/RoleStore";
import ServiceShiftWorkStore from "./ShiftWork/ServiceShiftWork/ServiceShiftWorkStore";
import ShiftWorkStore from "./ShiftWork/ShiftWork/ShiftWorkStore";
import WorkingSlotStore from "./ShiftWork/WorkingSlot/WorkingSlotStore";
import ConversionQuantityUnitStore from "./Supplements/ConversionQuantityUnit/ConversionQuantityUnitStore";
import NutraceuticalsStore from "./Supplements/Nutraceuticals/NutraceuticalsStore";
import NutritionOrderStore from "./Supplements/NutritionOrder/NutritionOrderStore";
import ModuleStore from "./SystemManagement/Module/ModuleStore";
import PermissionStore from "./SystemManagement/Permission/PermissionStore";
import RoleExStore from "./SystemManagement/Role/RoleStore";
import SysFunctionStore from "./SystemManagement/SysFunction/SysFunctionStore";
import SystemConfigStore from "./SystemManagement/SystemConfig/SystemConfigStore";
import TreatmentPlanCardStore from "./TreatmentPlanCard/TreatmentPlanCardStore";
import UserAccountStore from "./UserAccount/UserAccountStore";
import VisitTypeStore from "./VisitType/VisitTypeStore";

export const ManagementStore = {
  countryStore: new CountryStore(),
  professionStore: new ProfessionStore(),
  ethnicsStore: new EthnicsStore(),
  diagnosticConceptTemplateStore: new DiagnosticConceptTemplateStore(),
  administrativeUnitStore: new AdministrativeUnitStore(),
  serviceTypeStore: new ServiceTypeStore(),
  serviceFeeStore: new ServiceFeeStore(),
  visitTypeStore: new VisitTypeStore(),
  encounterTypeStore: new EncounterTypeStore(),
  healthCareRoomStore: new HealthCareRoomStore(),
  conceptTypeStore: new ConceptTypeStore(),
  healthCareServiceStore: new HealthCareServiceStore(),
  conceptAttributeTypeStore: new ConceptAttributeTypeStore(),
  personAttributeTypeStore: new PersonAttributeTypeStore(),
  conceptDataTypeStore: new ConceptDataTypeStore(),
  userAccountStore: new UserAccountStore(),
  departmentStore: new DepartmentStore(),
  roleStore: new RoleStore(),
  positionStore: new PositionStore(),
  serviceRequestSetStore: new ServiceRequestSetStore(),
  conceptStore: new ConceptStore(),
  drugGroupStore: new DrugGroupStore(),
  drugStore: new DrugStore(),
  hospitalBedStore: new HospitalBedStore(),
  serviceRequestSetTypeStore: new ServiceRequestSetTypeStore(),
  dosageStore: new DosageStore(),
  quantityUnitStore: new QuantityUnitStore(),
  insurancePaymentTypeStore: new IPTRStore(),
  medicalSupplyStore: new MedicalSupplyStore(),
  medicalEquipmentStore: new MedicalEquipmentStore(),
  serviceRoleStore: new ServiceRoleStore(),
  productMappingStore: new ProductMappingStore(),
  drugInteractionsStore: new DrugInteractionsStore(),
  organizationStore: new OrganizationStore(),
  drugRouteStore: new DrugRouteStore(),
  fundingSourceStore: new FundingSourceStore(),
  interestRatePeriodStore: new InterestRatePeriodStore(),
  serviceGroupStore: new ServiceGroupStore(),
  permissionStore: new PermissionStore(),
  moduleStore: new ModuleStore(),
  roleExStore: new RoleExStore(),
  stockOutStore: new StockOutStore(),
  marketingStore: new MarketingStore(),
  marketingVoucherStore: new MarketingVoucherStore(),
  conceptFormStore: new ConceptFormStore(),
  medicationRequestFormStore: new MedicationRequestFormStore(),
  specialistStore: new SpecialistStore(),
  shiftWorkStore: new ShiftWorkStore(),
  workingSlotStore: new WorkingSlotStore(),
  serviceShiftWorkStore: new ServiceShiftWorkStore(),
  medicalSupplyRequestFormStore: new MedicalSupplyRequestFormStore(),
  iCDCodeServiceStore: new ICDCodeServiceStore(),
  iCDMedicalSupplyRequestFormStore: new ICDMedicalSupplyRequestFormStore(),
  icdCodeConceptStore: new ICDCodeConceptStore(),
  iCDCodeMedicationRequestFormStore: new ICDCodeMedicationRequestFormStore(),
  conceptSymptomStore: new ConceptSymptomStore(),
  nutraceuticalsStore: new NutraceuticalsStore(),
  buildingStore: new BuildingStore(),
  storeConfigStore: new StoreConfigStore(),
  nutritionOrderStore: new NutritionOrderStore(),
  medicalRecordSummaryTypeStore: new MedicalRecordSummaryTypeStore(),
  drugStoreInventory: new DrugStoreInventory(),
  screenTemplateStore: new ScreenTemplateStore(),
  serviceConflicAlertStore: new ServiceConflicAlertStore(),
  conceptAlertStore: new ConceptAlertStore(),
  ingusionFormulaStore: new IngusionFormulaStore(),
  conceptDrugStore: new ConceptDrugStore(),
  medicalRecordSectionConfigStore: new MedicalRecordSectionConfigStore(),
  globalPropertyStore: new GlobalPropertyStore(),
  activitylogStore: new ActivityLogStore(),
  sysFunctionStore: new SysFunctionStore(),
  systemConfigStore: new SystemConfigStore(),
  conversionQuantityUnitStore: new ConversionQuantityUnitStore(),
  patientTypeServiceStore: new PatientTypeServiceStore(),
  subclinicalSubjectStore: new SubclinicalSubjectStore(),
  voucherCategoryStore: new VoucherCategoryStore(),
  customerSourceGroupStore: new CustomerSourceGroupStore(),
  customerSourceStore: new CustomerSourceStore(),
  bloodProductStore: new BloodProductStore(),
  sampleManagementStore: new SampleManagementStore(),
  surgeryProcedureTypeStore: new SurgeryProcedureTypeStore(),
  healthCheckCampainStore: new HealthCheckCampainStore(),
  globalPropotiesStore: new GlobalPropotiesStore(),
  revenueExpenditureStore: new RevenueExpenditureStore(),
  roomAndServiceStore: new RoomAndServiceStore(),
  medicalEquipmentTypeStore: new MedicalEquipmentTypeStore(),
  patientGroupTypeStore: new PatientGroupTypeStore(),
  patientTypeStore: new PatientTypeStore(),
  patientRankStore: new PatientRankStore(),
  paymentMethodStore: new PaymentMethodStore(),
  clientCardStore: new ClientCardStore(),
  treatmentPlanCardStore: new TreatmentPlanCardStore(),
  vatStore: new VatStore(),
  abstractProductStore: new AbstractProductStore(),
  clientAwardTypeStore: new ClientAwardTypeStore(),
  reasonCancelStore: new ReasonCancelStore(),
  asyncManagementStore: new AsyncManagementStore(),
  patientAsyncStore: new PatientAsyncStore(),
  treatmentAsyncStore: new TreatmentAsyncStore(),
  appointmentAsyncStore: new AppointmentAsyncStore(),
  serviceAsyncStore: new ServiceAsyncStore(),
  cardAsyncStore: new CardAsyncStore(),
  productAsyncStore: new ProductAsyncStore(),
  feeAsyncStore: new FeeAsyncStore(),
  checkInAsyncStore: new CheckInAsyncStore(),
  checkInVoidedAsyncStore: new CheckInVoidedAsyncStore(),
  appointmentVoidedAsyncStore: new AppointmentVoidedAsyncStore(),
  treatmentVoidedAsyncStore: new TreatmentVoidedAsyncStore(),
  feeVoidedAsyncStore: new FeeVoidedAsyncStore(),
  serviceVoidedAsyncStore: new ServiceVoidedAsyncStore(),
  cardVoidedSyncStore: new CardVoidedSyncStore(),
  productVoidedAsyncStore: new ProductVoidedAsyncStore(),
  patientMergeStore: new PatientMergeStore(),
  hisToCrmHistoryAsyncStore: new HisToCrmHistoryAsyncStore(),
  promotionProgramStore: new PromotionProgramStore(),
  salaryPeriodStore: new SalaryPeriodStore(),
  employeeStatusStore: new EmployeeStatusStore(),
  permissionStaffStore: new PermissionStaffStore(),
  staffGroupStore: new StaffGroupStore(),
  menuStore: new MenuStore(),
};
